document.addEventListener('DOMContentLoaded', function() {
  const widgetContainer = document.getElementById('bundle-builder-widget');
  const jsonElement = document.getElementById('BundleVariantsJson');
  
  if (!jsonElement || !widgetContainer) return;

  const variantsData = JSON.parse(jsonElement.textContent);
  let bundleState = {};
  let selectedColor = null;
  let selectedVariantId = null;

  let mainVariantId = parseInt(widgetContainer.getAttribute('data-main-variant'), 10);
  let mainVariantData = variantsData.find(v => v.id === mainVariantId);
  let maxBundleItems = parseInt(widgetContainer.getAttribute('data-max-items'), 10) || 4;
  
  const initialActions = document.getElementById('bundle-initial-actions');
  const buyNowBtn = document.getElementById('buy-now-btn');
  const startBundleBtn = document.getElementById('start-bundle-btn');
  
  const mainInterface = document.getElementById('bundle-main-interface');
  const mainItemContainer = document.getElementById('bundle-main-item');
  const colorSelectBox = document.getElementById('color-custom-select');
  const colorSelectedValue = document.getElementById('color-selected-value');
  const colorOptionsList = document.getElementById('color-options-list');
  const sizeSelect = document.getElementById('size-select');
  const addBtn = document.getElementById('add-variant-btn');
  const addRow = document.getElementById('bundle-add-row');
  const addedItemsContainer = document.getElementById('bundle-added-items');
  const discountMessage = document.getElementById('bundle-discount-message');
  const progressBar = document.getElementById('bw-progress-bar');
  const discountText = document.getElementById('bw-discount-text');
  const submitBundleBtn = document.getElementById('submit-bundle-to-cart');

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!mainVariantId) return;

      buyNowBtn.innerHTML = 'Agregando...';
      buyNowBtn.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: mainVariantId, quantity: 1 }] })
      })
      .then(response => {
        if (!response.ok) throw new Error('Error de stock');
        return response.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        }));
        buyNowBtn.innerHTML = '¡Agregado con éxito!';
        
        setTimeout(() => {
          buyNowBtn.innerHTML = 'Comprar ahora';
          buyNowBtn.disabled = false;
        }, 3000);
      })
      .catch(err => {
        buyNowBtn.innerHTML = 'Sin stock disponible';
        setTimeout(() => {
          buyNowBtn.innerHTML = 'Comprar ahora';
          buyNowBtn.disabled = false;
        }, 4000);
      });
    });
  }

  if(startBundleBtn && mainInterface && initialActions) {
    startBundleBtn.addEventListener('click', function() {
      initialActions.style.display = 'none';
      mainInterface.style.display = 'block';
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format(cents / 100);
  }

  function updateBundleTotal() {
    let totalCents = 0;
    let totalQuantity = 0;
    
    if (mainVariantData) {
      totalCents += mainVariantData.price;
      totalQuantity += 1;
    }

    Object.keys(bundleState).forEach(id => {
      const vId = parseInt(id, 10);
      const vData = variantsData.find(v => v.id === vId);
      const qty = bundleState[id].quantity;
      if (vData) {
        totalCents += (qty * vData.price);
        totalQuantity += qty;
      }
    });

    let discountPercent = 0;
    let progressWidth = 0;
    let messageHtml = "";

    // NUEVA CONFIGURACIÓN DE DESCUENTOS SOLICITADA
    if (maxBundleItems === 2) {
      if (totalQuantity === 1) {
        progressWidth = 50;
        messageHtml = `Agrega 1 prenda más para desbloquear <strong class="bw-highlight">10% de descuento</strong>`;
      } else if (totalQuantity >= 2) {
        discountPercent = 10;
        progressWidth = 100;
        messageHtml = `✨ ¡Felicidades! Tienes tu pack x2 con <strong class="bw-highlight">10% de descuento</strong> aplicado.`;
      }
    } else {
      if (totalQuantity === 1) {
        progressWidth = 25;
        messageHtml = `Agrega 1 prenda más para desbloquear <strong class="bw-highlight">10% de descuento</strong>`;
      } else if (totalQuantity === 2) {
        discountPercent = 10;
        progressWidth = 50;
        messageHtml = `¡Tienes <strong class="bw-highlight">10% de descuento</strong>! Agrega 1 más para el <strong class="bw-highlight">20%</strong>`;
      } else if (totalQuantity === 3) {
        discountPercent = 20;
        progressWidth = 75;
        messageHtml = `¡Alcanzaste <strong class="bw-highlight">20% de descuento</strong>! Agrega 1 más para el <strong class="bw-highlight">30%</strong>`;
      } else if (totalQuantity >= 4) {
        discountPercent = 30;
        progressWidth = 100;
        messageHtml = `✨ ¡Felicidades! Tienes el descuento máximo del <strong class="bw-highlight">30%</strong> aplicado a tu pack!`;
      }
    }

    const discountAmount = Math.round(totalCents * (discountPercent / 100));
    const finalPrice = totalCents - discountAmount;

    if (discountMessage) {
      discountMessage.style.display = 'block';
      if (progressBar) progressBar.style.width = `${progressWidth}%`;
      if (discountText) discountText.innerHTML = messageHtml;
    }

    if (addRow) {
      addRow.style.display = totalQuantity >= maxBundleItems ? 'none' : 'flex';
    }

    const hasItems = Object.keys(bundleState).length > 0;
    submitBundleBtn.disabled = !hasItems;
    
    if (hasItems) {
      if (discountPercent > 0) {
        submitBundleBtn.innerHTML = `Agrega tu pack por ${formatMoney(finalPrice)} <span style="font-size: 0.85em; font-weight: normal; margin-left: 5px;">(-${discountPercent}% descuento)</span>`;
      } else {
        submitBundleBtn.innerHTML = `Agrega tu pack por ${formatMoney(finalPrice)}`;
      }
    } else {
      submitBundleBtn.innerHTML = 'Agrega tu pack';
    }
  }

  function renderMainItem() {
    if (mainVariantData && mainItemContainer) {
      const img = mainVariantData.img ? `<img src="${mainVariantData.img}" width="24" height="24" style="border-radius:4px; object-fit: cover; flex-shrink: 0;">` : `<div style="width:24px; height:24px; background:#ccc; border-radius:4px; flex-shrink: 0;"></div>`;
      mainItemContainer.innerHTML = `
        <div class="bw-row">
          <div class="bw-color" style="background: #f5f5f5; border-color: #e0e0e0;">
            ${img}
            <span style="color: #888;">${mainVariantData.color || ''}</span>
          </div>
          <div class="bw-size" style="background: #f5f5f5; border-color: #e0e0e0; color: #888;">
            ${mainVariantData.size || ''}
          </div>
          <button type="button" class="bw-btn" disabled>
            Actual
          </button>
        </div>
      `;
    }
    updateBundleTotal();
  }

  function updateMainVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariant = urlParams.get('variant');
    let currentId = mainVariantId;

    if (urlVariant) {
      currentId = parseInt(urlVariant, 10);
    } else {
      const idInput = document.querySelector('form[action*="/cart/add"] [name="id"], m-product-form [name="id"]');
      if (idInput && idInput.value) {
        currentId = parseInt(idInput.value, 10);
      }
    }

    if (currentId && currentId !== mainVariantId) {
      const foundData = variantsData.find(v => v.id === currentId);
      if (foundData) {
        mainVariantId = currentId;
        mainVariantData = foundData;
        renderMainItem(); 
      }
    }
  }

  const originalReplaceState = history.replaceState;
  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    setTimeout(updateMainVariant, 50);
  };
  const originalPushState = history.pushState;
  history.pushState = function() {
    originalPushState.apply(this, arguments);
    setTimeout(updateMainVariant, 50);
  };
  window.addEventListener('popstate', updateMainVariant);

  document.addEventListener('change', function(e) {
    if(e.target.closest('form[action*="/cart/add"]') || e.target.closest('m-product-form')) {
      setTimeout(updateMainVariant, 100);
    }
  });

  renderMainItem();

  const uniqueColors = [...new Set(variantsData.map(v => v.color))];

  uniqueColors.forEach(function(colorName) {
    const firstVariantWithColor = variantsData.find(v => v.color === colorName);
    const li = document.createElement('li');
    li.style.padding = '10px';
    li.style.cursor = 'pointer';
    li.style.display = 'flex';
    li.style.alignItems = 'center';
    li.style.gap = '10px';
    li.style.borderBottom = '1px solid #eee';

    let imgHTML = firstVariantWithColor.img ? `<img src="${firstVariantWithColor.img}" width="28" height="28" style="border-radius: 4px; object-fit: cover;">` : `<div style="width:28px; height:28px; background:#eee; border-radius:4px;"></div>`;
    
    li.innerHTML = `${imgHTML} <span style="color:#000;">${colorName}</span>`;
    
    li.addEventListener('click', function(e) {
      e.stopPropagation();
      selectedColor = colorName;
      colorSelectedValue.innerHTML = li.innerHTML;
      colorSelectedValue.style.color = "#000";
      colorOptionsList.style.display = 'none';
      updateSizeDropdown();
    });

    colorOptionsList.appendChild(li);
  });

  colorSelectBox.addEventListener('click', function(e) {
    e.stopPropagation();
    colorOptionsList.style.display = colorOptionsList.style.display === 'none' ? 'block' : 'none';
  });

  document.addEventListener('click', function() {
    colorOptionsList.style.display = 'none';
  });

  function updateSizeDropdown() {
    sizeSelect.innerHTML = '<option value="">Talla</option>';
    const availableVariants = variantsData.filter(v => v.color === selectedColor);
    
    if (availableVariants.length > 0) {
      sizeSelect.disabled = false;
      sizeSelect.style.background = '#fff';
      availableVariants.forEach(function(v) {
        const option = document.createElement('option');
        option.value = v.id;
        option.textContent = v.size; 
        sizeSelect.appendChild(option);
      });
    }
    selectedVariantId = null;
    validateAddButton();
  }

  sizeSelect.addEventListener('change', function(e) {
    selectedVariantId = e.target.value;
    validateAddButton();
  });

  function validateAddButton() {
    if (selectedVariantId && selectedVariantId !== "") {
      addBtn.disabled = false;
    } else {
      addBtn.disabled = true;
    }
  }

  addBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    let totalQtySoFar = mainVariantData ? 1 : 0;
    Object.keys(bundleState).forEach(id => totalQtySoFar += bundleState[id].quantity);
    if (totalQtySoFar >= maxBundleItems) return;

    const vId = parseInt(selectedVariantId, 10);
    const variant = variantsData.find(v => v.id === vId);

    if (!variant) return;

    const currentInBundle = bundleState[vId] ? bundleState[vId].quantity : 0;
    const qtyToValidate = (vId === mainVariantId) ? currentInBundle + 1 : currentInBundle;

    if (qtyToValidate >= variant.qty) {
      const originalText = addBtn.textContent;
      addBtn.textContent = 'Sin stock';
      addBtn.style.color = '#d9534f';
      setTimeout(() => {
        addBtn.textContent = originalText;
        addBtn.style.color = '';
      }, 2000);
      return;
    }

    if (bundleState[vId]) {
      bundleState[vId].quantity += 1;
    } else {
      bundleState[vId] = {
        quantity: 1,
        color: variant.color,
        size: variant.size,
        img: variant.img
      };
    }
    
    sizeSelect.value = "";
    selectedVariantId = null;
    validateAddButton();
    renderBundleUI();
  });

  function renderBundleUI() {
    addedItemsContainer.innerHTML = '';
    const ids = Object.keys(bundleState);
    
    ids.forEach(function(id) {
      const item = bundleState[id];
      const row = document.createElement('div');
      row.className = 'bw-row';
      
      const imgHTML = item.img ? `<img src="${item.img}" width="24" height="24" style="border-radius:4px; object-fit: cover; flex-shrink: 0;">` : `<div style="width:24px; height:24px; background:#eee; border-radius:4px; flex-shrink: 0;"></div>`;
      
      const qtyText = item.quantity > 1 ? `<strong>${item.quantity}x</strong>&nbsp;` : '';

      row.innerHTML = `
        <div class="bw-color">
          ${imgHTML}
          <span>${item.color}</span>
        </div>
        <div class="bw-size">
          ${qtyText}${item.size}
        </div>
        <button type="button" data-remove="${id}" class="bw-btn bw-btn-remove" style="font-size: 16px;">
          ✕
        </button>
      `;
      addedItemsContainer.appendChild(row);
    });

    document.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        delete bundleState[e.target.getAttribute('data-remove')];
        renderBundleUI();
      });
    });

    updateBundleTotal();
  }

  submitBundleBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    submitBundleBtn.innerHTML = 'Agregando...';
    submitBundleBtn.disabled = true;

    const items = Object.keys(bundleState).map(id => ({
      id: parseInt(id, 10),
      quantity: bundleState[id].quantity
    }));

    if (mainVariantId) {
      const mainInBundle = items.find(i => i.id === mainVariantId);
      if (mainInBundle) {
        mainInBundle.quantity += 1;
      } else {
        items.unshift({ id: mainVariantId, quantity: 1 });
      }
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw new Error(err.description || "Error de stock"); });
      }
      return response.json();
    })
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: true }
      }));

      bundleState = {};
      renderBundleUI();
      
      mainInterface.style.display = 'none';
      if(initialActions) initialActions.style.display = 'flex';
      
      startBundleBtn.innerHTML = '¡Pack agregado con éxito!';
      
      setTimeout(() => {
        startBundleBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> Personaliza tu pack y ahorra';
      }, 3000);

    })
    .catch(err => {
      submitBundleBtn.innerHTML = err.message.includes('existencia') ? 'Sin stock disponible' : 'Error al agregar';
      setTimeout(() => {
        updateBundleTotal();
        submitBundleBtn.disabled = false;
      }, 4000);
    });
  });
});